// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-align-center[data-v-7f2186e4] {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/home/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACI;EACI,kBAAA;ACAR","sourcesContent":["\n    .text-align-center {\n        text-align: center;\n    }\n",".text-align-center {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
